import { Grid } from "@material-ui/core";
import styled from "styled-components";
import { EditProfilePrizes } from "../../../author/edit-profile/edit-profile-prizes";
import { BoxWrapper } from "../../../box-wrapper/box-wrapper";
import { StyledCheckbox } from "../../../form/checkbox";
import { StyledInput } from "../../../form/input";
import prizes from "../../../../img/prizes.png";
import {StyledTextarea} from "../../../form/textarea";
import React from "react";
import {useTranslation} from "react-i18next";

export const AddBookFormStep2: React.FC<Props> = (
    {
        handleChange,
        setFieldValue,
        values,
        errors,
        touched
    }
) => {
    const {t} = useTranslation(['publisher', 'common']);

    return (
        <Grid
            container
            direction="row"
            spacing={2}
        >
            <Grid container item sm={12} md={6} direction={'column'} spacing={2}>
                <Grid container item direction={'column'}>
                    <StyledTextarea
                        id="description"
                        label={t('addBookNew.form.description')}
                        onChange={handleChange}
                        value={values.description}
                        rows={12}
                    />
                </Grid>

                <Grid container item direction={'column'}>
                    <StyledTextarea
                        id="summary"
                        label={t('addBookNew.form.summary')}
                        onChange={handleChange}
                        value={values.summary}
                        rows={12}
                    />
                </Grid>
            </Grid>

            <Grid container item sm={12} md={6} direction={'column'} spacing={2}>
                <Grid container item direction={'column'}>
                    <StyledTextarea
                        id="review"
                        label={t('addBookNew.form.review')}
                        onChange={handleChange}
                        value={values.review}
                        rows={10}
                    />
                </Grid>

                <Grid container item direction={'column'}>
                    <StyledTextarea
                        id="partOfBook"
                        label={t('addBookNew.form.partOfBook')}
                        onChange={handleChange}
                        value={values.partOfBook}
                        rows={10}
                    />
                </Grid>

                <Grid container item direction={'column'}>
                    <StyledTextarea
                        id="tableOfContents"
                        label={t('addBookNew.form.tableOfContents')}
                        onChange={handleChange}
                        value={values.tableOfContents}
                        rows={10}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}

interface Props {
    handleChange: any;
    setFieldValue: any;
    values: any;
    errors: any;
    touched: any;
}
